import { memo } from 'react';
import styled from '@emotion/styled';
import { formatWithCommas } from '@trinity/chat-components/utils/chart';

type Props = {
  name: string | number;
  count: number;
  columnN?: number;
  unit?: string;
  isPrefix?: boolean;
};

export const ChartHoverText = memo((props: Props) => {
  const formatValue = () => {
    const formatted = formatWithCommas(props.count);
    if (props.unit) {
      return props.isPrefix ? `${props.unit}${formatted}` : `${formatted}${props.unit}`;
    }
    return formatted;
  };

  const label = props.unit ? 'Value' : 'Count';

  return (
    <Root>
      <Header>{props.name}</Header>
      <StatsRow>
        <div>
          {label}: {formatValue()}
          {props.columnN !== undefined && ` (Column n: ${props.columnN})`}
        </div>
      </StatsRow>
    </Root>
  );
});

// make root skinnier more vertical space less horizontal space
const Root = styled.div`
  background: white;
  padding: 9px 12px;
  border: 1px solid #ccc;
  min-width: 200px;
`;

const Header = styled.div(({ theme }) => ({
  fontFamily: theme.fonts?.semiBold ?? 'inherit',
}));

const StatsRow = styled.div`
  display: flex;
  gap: 2rem;
`;
